// extracted by mini-css-extract-plugin
export var actualiteCategorie = "actualites-module--actualite-categorie--c3232";
export var actualiteContainer = "actualites-module--actualiteContainer--85b60";
export var actualiteContainerFirst = "actualites-module--actualiteContainerFirst--ca145";
export var actualiteInfos = "actualites-module--actualite-infos--d9983";
export var actualiteResume = "actualites-module--actualite-resume--c43e7";
export var actualiteTitle = "actualites-module--actualite-title--ee1b0";
export var actualitesContainer = "actualites-module--actualites-container--80ca9";
export var actualitesDescription = "actualites-module--actualites-description--924a1";
export var autresActualites = "actualites-module--autres-actualites--956e2";
export var editButtonFirstActu = "actualites-module--edit-button-first-actu--aa54b";
export var editButtonTitle = "actualites-module--edit-button-title--4bd61";
export var listActualitesContainer = "actualites-module--list-actualites-container--43618";
export var listActualitesTitle = "actualites-module--list-actualites-title--fe142";